import type Quill from 'quill/core';
import type { Parchment } from 'quill/core';
import Module from 'quill/core/module';
import findQuillByBlot from './utils/findQuillByBlot';
import type { EntityUploadType } from '../graphql/generated/graphql';

export type AssetUploaderOptions = {
  sendFileToServer: (
    source: File | string,
    type: EntityUploadType,
  ) => Promise<string | null>;
  canReuseFileUrl: (source: File | string) => boolean;
};

export default class AssetUploader extends Module<AssetUploaderOptions> {
  static moduleName = 'assetUploader';

  static get(quill: Quill | null) {
    return quill?.getModule(AssetUploader.moduleName) as
      | AssetUploader
      | undefined;
  }

  static getForBlot(blot: Parchment.Blot) {
    const quill = findQuillByBlot(blot);
    return this.get(quill);
  }

  sendFileToServer: AssetUploaderOptions['sendFileToServer'];
  canReuseFileUrl: AssetUploaderOptions['canReuseFileUrl'];

  constructor(quill: Quill, options: AssetUploaderOptions) {
    super(quill, options);
    this.sendFileToServer = options.sendFileToServer;
    this.canReuseFileUrl = options.canReuseFileUrl;
  }
}
